export default __webpack_public_path__ + "static/media/ronov.74b9f1e4.jpg";